module.exports = __webpack_public_path__ + "static/media/ic-cart.4ab9aaad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-cart.svg
// module id = 608
// module chunks = 14